import {Environment} from '../environment';
import {DetailedEnvironment} from '../detailed-environment';
import {PageDto} from '../page-dto';

export interface EnvironmentState {
  environments: PageDto<Environment>;
  isLoadingPage: boolean;
  detailedEnvironment: DetailedEnvironment;
  showAll: boolean;
}

export const INIT_ENVIRONMENTS_STATE: PageDto<Environment> = {
  pageable: {
    pageSize: 10,
    pageNumber: 0,
    first: true,
    last: false,
    totalElements: 0,
    totalPages: 1,
  },
  content: [],
};

export const INIT_DETAILED_ENVIRONMENT_STATE: DetailedEnvironment = {
  id: '',
  b2cId: '',
  lastUpdated: '',
  customerId: '',
  systemInfo: {
    ip: '',
    mac: '',
    osName: '',
    hostName: '',
    totalSystemMemory: 0,
    availableSystemMemory: 0,
    osArchitecture: '',
    osVersion: '',
    osLastReboot: undefined,
  },
  softwareInfo: {
    technicalInfo: {
      userName: '',
      homeDirectory: '',
      workingDirectory: '',
      baseURL: '',
      webServer: '',
      tomcatVersion: '',
      jdks: [],
      cobolInfo: {
        version: '',
      },
      cloudLinkInfo: {
        version: '',
        javaEnvironment: {
          version: '',
          installationDirectory: '',
          maxMemory: 0,
          processors: 0,
          totalMemory: 0,
          vendor: '',
          configName: '',
        },
        connectionResults: [],
        processedFeedbacks: [],
      },
    },
    functionalInfo: {
      products: [],
      designation: {
        enumName: '',
        sortWeight: 0,
      },
      providedReleaseFolder: '',
      providedConfigNumber: 0,
      menuInfo: {
        etmMenuEnabled: false,
        totalUsers: 0,
        masterF1Users: 0,
        convertedUsers: 0,
      },
      soFiPamInfo: {
        enabled: true,
        version: '1.0.0',
        installedOn: 100,
        lastCheckedOn: 100,
      },
    },
  },
  isConnectionHealthy: false,
  freeFields: [],
};
